// Models
import { CreateMemberRequestParams, SanitizedMember } from 'models/Member'

// Redux services
import { createMember, listMembers } from 'redux/services/member'

// Local
import { RootState, TypedDispatch } from 'redux/store'

/**
 * Since the query to fetch a member and filter my email can be expensive. We optimize
 * the process by attempting to create a member first before attempting to fetch one.
 *
 * If the creation fails (which will happen if the member already exists) we'll
 * then try and retreive the existing member. For most donors there will not be
 * a pre-existing member.
 *
 * @param store
 * @param dispatch
 * @returns member
 */
const findOrCreateMember = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
): Promise<SanitizedMember> => {
  let member: SanitizedMember | undefined = undefined

  const newMember: CreateMemberRequestParams = {
    address1: store.order.billingDetails.address.line1,
    address2: store.order.billingDetails.address.line2,
    city: store.order.billingDetails.address.city,
    country: store.order.billingDetails.address.country,
    first_name: store.order.billingDetails.firstName,
    last_name: store.order.billingDetails.lastName,
    postal_code: store.order.billingDetails.address.postalCode,
    state: store.order.billingDetails.address.state,
    email_address: store.order.billingDetails.email,
    phone: store.order.billingDetails.phone,
  }

  const result = await dispatch(createMember.initiate(newMember)).unwrap()

  if (
    'error' in result &&
    result.error.email_address.includes('This email address is already used.')
  ) {
    const results = await dispatch(
      listMembers.initiate({ filter: { email_address: store.order.billingDetails.email } }),
    ).unwrap()

    member = results?.[0]
  } else {
    member = result as SanitizedMember
  }

  return member
}

export default findOrCreateMember
